import DiscussionList from 'flarum/forum/components/DiscussionList';
export default class PrivateDiscussionList extends DiscussionList {}
flarum.reg.add('fof-byobu', 'forum/pages/discussions/PrivateDiscussionList', PrivateDiscussionList);